<template>
    <section class="gh-section gh-section-experts s-wrapper">
        <div class="container">
            <h3 class="gh-section__heading">
                <slot name="heading">Learn From {{ LaraVue.figure.totalAuthors }}+ Global Experts</slot>
            </h3>
            <p class="gh-section__subheading">
                {{ intro }}
            </p>
            <p class="s-leading-text">
                <slot name="text">Learn from experts from some of the world’s leading institutions, including:</slot>
            </p>
            <ul class="s-experts">
                 <li v-for="expert in experts" :key="expert.name" class="s-expert">
                     <img :src="expert.logo" :alt="expert.name" class="s-expert__logo">
                 </li>
            </ul>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            subheading: {
                type: String
            },

            hours: {
                type: String,
                default: '600'
            }
        },

        data () {
            return {
                experts: [],
                windowWidth: window.innerWidth
            }
        },

        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
            this.setupExperts();
        },

        methods: {
            handleResize() {
                this.windowWidth = window.innerWidth;
            },

            setupExperts () {
                let indentify = '';
                if (this.windowWidth < 768) {
                    indentify = '2';
                }

                this.experts = [
                    {
                        name: 'Xavier University of Louisiana',
                        logo: '/images/promo/eofy/global-expert-xavier.svg',
                        url: '',
                    },
                    {
                        name: 'Harvard Medical School',
                        logo: '/images/promo/eofy/global-expert-harvard.svg',
                        url: '',
                    },
                    {
                        name: 'Queensland University of Technology',
                        logo: `/images/promo/eofy/global-expert-qut${indentify}.svg`,
                        url: '',
                    },
                    {
                        name: 'University of Queensland',
                        logo: '/images/promo/eofy/global-expert-uq.svg',
                        url: '',
                    },
                    {
                        name: 'University of Pennsylvania',
                        logo: '/images/promo/eofy/global-expert-pennuni.svg',
                        url: '',
                    },
                    {
                        name: 'MiCBT Institute',
                        logo: '/images/promo/eofy/global-expert-micbt.svg',
                        url: '',
                    },
                    {
                        name: 'Monash University',
                        logo: '/images/promo/eofy/global-expert-monash.svg',
                        url: '',
                    },
                    {
                        name: 'Boston University',
                        logo: '/images/promo/eofy/global-expert-boston.svg',
                        url: '',
                    },
                    {
                        name: 'The University of Melbourne',
                        logo: `/images/promo/eofy/global-expert-unimelbourne${indentify}.svg`,
                        url: '',
                    },
                    {
                        name: 'Macquarie University',
                        logo: '/images/promo/eofy/global-expert-macquarie.svg',
                        url: '',
                    },
                    {
                        name: 'UNSW Sydney',
                        logo: '/images/promo/eofy/global-expert-unsw.svg',
                        url: '',
                    },
                    {
                        name: 'PennState',
                        logo: '/images/promo/eofy/global-expert-pennstate.svg',
                        url: '',
                    }
                ];
            }
        },

        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },

        computed: {
            intro() {
                return this.subheading ||
                `Our catalogue includes over ${this.hours} hours of learning, developed and delivered by internationally-renowned, award-winning authors, practitioners, researchers and educators.`
            },

            LaraVue() {
                return LaraVue
            }
        },

        watch: {
            windowWidth() {
                this.setupExperts()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .s-wrapper {
        background: #CFE9D9;
        color: #005A46;
        text-align: center;
    }

    .s-leading-text {
        margin-bottom: 2rem;
        font-weight: 700;
        font-size: 1.3rem;
    }

    .gh-section__subheading {
        max-width: 832px;
        width: 100%;
        margin: auto;
    }

    .s-experts {
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: center;
    }

    .s-expert {
        display: flex;
        padding: .5rem;

        img {
            width: 100%;
            max-width: 110px;
            height: auto;
            width: auto;
            margin: 0 auto;
            border-radius: 5px;
            box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.1);
        }
    }

    @media screen and (min-width: '375px') {
        .s-expert {
            img {
                max-width: 151px;
            }
        }
    }

    @media screen and (min-width: '411px') {
        .s-expert {
            img {
                max-width: 169px;
            }
        }
    }
    @media screen and (min-width: '500px') {
        .s-expert {
            img {
                max-width: 213px;
                height: 85px;
                max-height: initial;
            }
        }
    }
</style>
